<template>
  <div class="user-like">
    <user-link :user="source" />&nbsp;{{ likeIcon }}
  </div>
</template>

<script>
import UserLink from '../shared/UserLink'
import LikeService from '../../service/like.service'

export default {
  name: 'UserLikesVirtualItem',
  components: { UserLink },
  // https://github.com/tangbc/vue-virtual-scroll-list#simple-usage
  props: {
    index: {
      type: Number,
      default: 0
    },
    source: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    likeIcon() {
      return LikeService.getLikeIcon(this.source['likes.type'])
    }
  }
}
</script>

<style scoped lang="scss">
.user-like {
  display: flex;
  align-items: center;

  .listUsers {
    width: unset;
  }
}

</style>
